import {
  Box,
  Card,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { calendarEditIcon, listCheckIcon, personEditIcon } from "assets/images";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ISLPDetails } from "utils/interfaces/student-profile-details";
import {
  hasRequiredRole,
  hideLoaderForBatchApiCall,
  showLoaderForBatchApiCall,
} from "utils/helper";
import { DATE_VIEW_FORMAT, SPLA_ROLE_ID } from "utils/constants/constant";
import {
  AllocatePLAPayload,
  DeferSLPPayload,
  DeferSLPSuccessPayload,
  IUpdateContactDateRequestPayload,
  NextOrCurrentSLPPaylod,
  NextOrCurrentSLPSuccessPayload,
} from "store/studentProfileDetails/types";
import moment from "moment";
import NoRecords from "components/NoRecords";
import { AuthState } from "store/rootReducer";
import { AuthState as AuthType } from "store/auth/types";
import { getUserSelector } from "store/auth/selector";
import { useSelector } from "react-redux";
import {
  PLAUserListPayload,
  UpdateSLPContactProgressPayload,
} from "store/slpDashboard/type";
import AllocateSLPModal from "components/AllocateSLPModal";
import { AppRoutings } from "utils/enums/app-routings";
import { SLPFormStep } from "utils/enums/slp-form";
import GenericContactDate from "components/GenericContactDate";
import { ContactDateNumber } from "utils/enums/slp";
import DeferSLPModal from "components/DeferSLPModal";

// function CalendarIcon() {
//   return (
//     <div className="calendar-icon">
//       <img src={calendarIcon} alt="calendar" />
//     </div>
//   );
// }

interface INextOrCurrentSLPProps {
  nextOrCurrentSLPRequest: (payload: NextOrCurrentSLPPaylod) => void;
  deferSLPRequest: (payload: DeferSLPPayload) => void;
  plaUserListRequest: (payload: PLAUserListPayload) => void;
  allocatePLARequest: (payload: AllocatePLAPayload) => void;
  // eslint-disable-next-line
  updateSLPContactProgressRequest: (
    payload: UpdateSLPContactProgressPayload
  ) => {};
  updateContactDateRequest: (payload: IUpdateContactDateRequestPayload) => void;
}

const NextOrCurrentSLP: React.FC<INextOrCurrentSLPProps> = (props) => {
  const {
    nextOrCurrentSLPRequest,
    deferSLPRequest,
    plaUserListRequest,
    allocatePLARequest,
    updateContactDateRequest,
    // updateSLPContactProgressRequest,
  } = props;

  const user = useSelector<AuthState, AuthType["user"]>(getUserSelector);
  const history = useHistory();
  const location = useLocation<{ studentId: number; slpId: number }>();
  const { studentId } = location.state;
  const isSPLAUser = useMemo(
    () => hasRequiredRole(user?.roleID ?? [], SPLA_ROLE_ID),
    [user]
  );

  const [nextOrCurrentSLPDetails, setNextOrCurrentSLPDetails] =
    useState<ISLPDetails | null>();
  const [openDeferSLP, setOpenDeferSLP] = useState<boolean>(false);
  const [openAllocateModal, setOpenAllocateModal] = useState(false);
  // ------ CONTACT PROGRESS RELATED CODE -------
  // const [contactProgressModalDetail, setContactProgressModalDetail] =
  //   useState<IUpdateSLPContactProgressValue>();

  const onNextOrCurrentSLPSuccess = (
    response: NextOrCurrentSLPSuccessPayload
  ) => {
    setNextOrCurrentSLPDetails(response.slpDetails);
    hideLoaderForBatchApiCall();
  };

  const getNextOrCurrentSLP = () => {
    if (nextOrCurrentSLPRequest && studentId) {
      showLoaderForBatchApiCall();
      const payload = {
        values: { id: studentId },
        callback: onNextOrCurrentSLPSuccess,
      };
      nextOrCurrentSLPRequest(payload);
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    getNextOrCurrentSLP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDeferSLP = () => {
    setOpenDeferSLP(true);
  };

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const renderContactProgress = (status: string, onClick?: () => void) => {
  //   let icon = editYellowIcon;
  //   let className = "default";

  //   switch (status) {
  //     case "Not Started":
  //       icon = editYellowIcon;
  //       className = "not-started";
  //       break;
  //     case "Assigned":
  //       icon = editGreenIcon;
  //       className = "assigned";
  //       break;
  //     case "In Progress":
  //       icon = editBlueIcon;
  //       className = "in-progress";
  //       break;
  //     case "Active":
  //       icon = editPurpleIcon;
  //       className = "active";
  //       break;
  //     default:
  //       icon = editYellowIcon;
  //       className = "default";
  //   }

  //   return (
  //     <Button
  //       className={`btn-progress ${className}`}
  //       variant="outlined"
  //       onClick={onClick}
  //     >
  //       <img src={icon} alt="Icon" />
  //       <Typography variant="body2" className="w-auto">
  //         {status}
  //       </Typography>
  //     </Button>
  //   );
  // };

  const deferSLPCallback = (response: DeferSLPSuccessPayload) => {
    if (nextOrCurrentSLPDetails) {
      setNextOrCurrentSLPDetails({
        ...nextOrCurrentSLPDetails,
        dueDate: response.deferSLPDetails.dueDate,
      });
    }
  };

  const handleAllocateToPLA = () => {
    setOpenAllocateModal(true);
  };

  const updateAllocatePLACallback = () => {
    getNextOrCurrentSLP();
  };

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const handleContactProgressClick = (slp: ISLPDetails) => {
  //   setContactProgressModalDetail({
  //     id: slp.slpId,
  //     contactProgress: slp.contactProgress,
  //   });
  // };

  // const handleContactProgressModalClose = () => {
  //   setContactProgressModalDetail(undefined);
  // };

  // const updateContactProgressCallback = () => {
  //   toast.success(CONTACT_PROGRESS_UPDATE_MSG);
  //   getNextOrCurrentSLP();
  //   handleContactProgressModalClose();
  // };

  return (
    <Grid item xs={12}>
      <Card>
        <Box className="card-inner-head mb-24">
          <Typography variant="h3" sx={{ fontWeight: 500 }}>
            Next/Current SLP
          </Typography>
        </Box>
        <TableContainer>
          <Table className="table-h-md">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    maxWidth: "84px",
                    width: "84px",
                    minWidth: "84px",
                  }}
                >
                  SLP Number
                </TableCell>
                <TableCell sx={{ width: "154px", minWidth: "154px" }}>
                  Due/Deferred Until
                </TableCell>
                <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                  Allocated To
                </TableCell>
                {/* // ------ CONTACT PROGRESS RELATED CODE ------- */}
                {/* <TableCell
                  sx={{ width: "130px", minWidth: "130px" }}
                  align="center"
                >
                  Contact Progress
                </TableCell> */}
                <TableCell sx={{ width: "160px", minWidth: "160px" }}>
                  Contact Date 1
                </TableCell>
                <TableCell sx={{ width: "160px", minWidth: "160px" }}>
                  Contact Date 2
                </TableCell>
                <TableCell align="center" sx={{ width: "92px" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {nextOrCurrentSLPDetails && (
                <TableRow>
                  <TableCell component="th" scope="row" align="center">
                    {nextOrCurrentSLPDetails?.slpNumber}
                  </TableCell>
                  <TableCell>
                    {moment(nextOrCurrentSLPDetails?.dueDate)
                      .format(DATE_VIEW_FORMAT)
                      .toString()}
                  </TableCell>
                  <TableCell>
                    {nextOrCurrentSLPDetails?.allocatedToName ?? "-"}
                  </TableCell>
                  <TableCell>
                    <GenericContactDate
                      slpId={nextOrCurrentSLPDetails.slpId}
                      contactDateNumber={ContactDateNumber.ContactDateOne}
                      contactDate={nextOrCurrentSLPDetails.contactDateOne}
                      updateContactDateRequest={updateContactDateRequest}
                      updateSLPRequestsCallback={updateAllocatePLACallback}
                    />
                  </TableCell>
                  <TableCell>
                    <GenericContactDate
                      slpId={nextOrCurrentSLPDetails.slpId}
                      contactDateNumber={ContactDateNumber.ContactDateTwo}
                      contactDate={nextOrCurrentSLPDetails.contactDateTwo}
                      updateContactDateRequest={updateContactDateRequest}
                      updateSLPRequestsCallback={updateAllocatePLACallback}
                    />
                  </TableCell>
                  {/* // ------ CONTACT PROGRESS RELATED CODE ------- */}
                  {/* <TableCell align="center">
                    {renderContactProgress(
                      SLP_CONTACT_PROGRESS.filter(
                        (x) =>
                          x.value === nextOrCurrentSLPDetails?.contactProgress
                      )[0]?.label,
                      () => handleContactProgressClick(nextOrCurrentSLPDetails)
                    )}
                  </TableCell> */}
                  <TableCell align="center">
                    <div className="table-actions">
                      {isSPLAUser && (
                        <Tooltip title="Allocate" arrow>
                          <IconButton onClick={handleAllocateToPLA}>
                            <img src={personEditIcon} alt="Edit" />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="Defer SLP" arrow>
                        <IconButton onClick={handleDeferSLP}>
                          <img src={calendarEditIcon} alt="Edit" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Start SLP" arrow>
                        <IconButton
                          onClick={() =>
                            history.push({
                              pathname: AppRoutings.SLPForm,
                              state: {
                                studentId,
                                slpId: nextOrCurrentSLPDetails.slpId,
                                partNumber: SLPFormStep.HOPES_GOALS_AMBITIONS,
                              },
                            })
                          }
                        >
                          <img src={listCheckIcon} alt="Edit" />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {!nextOrCurrentSLPDetails && <NoRecords />}
        </TableContainer>
      </Card>
      {nextOrCurrentSLPDetails?.slpId && openAllocateModal && (
        <AllocateSLPModal
          allocatedToId={
            nextOrCurrentSLPDetails?.allocatedTo
              ? nextOrCurrentSLPDetails.allocatedTo
              : null
          }
          dueDate={nextOrCurrentSLPDetails.dueDate}
          slpId={nextOrCurrentSLPDetails?.slpId}
          openAllocateModal={openAllocateModal}
          setOpenAllocateModal={setOpenAllocateModal}
          updateAllocatePLACallback={updateAllocatePLACallback}
          allocatePLARequest={allocatePLARequest}
          plaUserListRequest={plaUserListRequest}
        />
      )}
      {/* Defer SLP Modal */}
      {nextOrCurrentSLPDetails?.dueDate && (
        <DeferSLPModal
          openDeferSLP={openDeferSLP}
          dueDate={nextOrCurrentSLPDetails?.dueDate}
          slpId={nextOrCurrentSLPDetails?.slpId}
          deferSLPRequest={deferSLPRequest}
          setOpenDeferSLP={setOpenDeferSLP}
          deferSLPCallback={deferSLPCallback}
        />
      )}
      {/* // ------ CONTACT PROGRESS RELATED CODE ------- */}
      {/* {!!contactProgressModalDetail && (
        <SLPContactProgressModal
          onClose={handleContactProgressModalClose}
          contactProgressDetail={contactProgressModalDetail}
          updateSLPContactProgressRequest={updateSLPContactProgressRequest}
          onSaveCallback={updateContactProgressCallback}
        />
      )} */}
    </Grid>
  );
};

export default NextOrCurrentSLP;
